<template>
    <el-popover placement="left"
                width="650"
                v-model="visible">
        <el-form>
            <el-table :data="currentLocalPresencePackages"
                      v-loading="loading">
                <el-table-column label="Line ID">
                    <template #default="{ row }">
                        {{ row.campaign?.id }}
                    </template>
                </el-table-column>
                <el-table-column label="Line Name">
                    <template #default="{ row }">
                        {{ row.campaign?.name }}
                    </template>
                </el-table-column>
                <el-table-column label="Package">
                    <template #default="{ row }">
                        {{ row.addon?.name }}
                    </template>
                </el-table-column>
                <el-table-column label="Country">
                    <template #default="{ row }">
                        {{ getCountry(row) }}
                    </template>
                </el-table-column>
                <el-table-column label="Price">
                    <template #default="{ row }">
                        {{ getPrice(row) | toCurrency }}
                    </template>
                </el-table-column>
                <el-table-column label="Options" :min-width="100">
                    <template #default="{ row }">
                        <el-button type="danger"
                                    :disabled="isInProgress(row)"
                                   @click.prevent="cancelLocalPresencePackage(row)">
                            {{ isInProgress(row) ? 'Deleting..' : 'Cancel' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-form>
        <button slot="reference"
                class="btn btn-sm btn-block red mt-2"
                :disabled="loading || !shouldShowButton">
            Cancel Local Presence
        </button>
    </el-popover>
</template>

<script>
import {addons_mixin} from '../../mixins'
import {ADDON_CATEGORY_LOCAL_PRESENCE} from '../../constants/addon-categories'
import * as LP from '../../constants/local-presence-options'

const LOCAL_PRESENCE_STATUS_SUCCESS = 3

export default {
    mixins: [addons_mixin],

    props: {
        company: {
            required: true,
            type: Object
        },
    },

    data() {
        return {
            loading: false,
            currentLocalPresencePackages: [],
            visible: false
        }
    },

    created() {
        VueEvent.listen('LOCAL_PRESENCE_PURCHASE', payload => {
            let {company, localPresencePurchase} = payload

            // If it's not the company id, or it's not a successful purchase, return
            if (company.id !== this.company.id || localPresencePurchase.status !== LOCAL_PRESENCE_STATUS_SUCCESS) {
                return
            }

            if (this.currentLocalPresencePackages === undefined) {
                this.currentLocalPresencePackages = []
            }

            let exists = this.currentLocalPresencePackages
                .filter(pack => pack.type === localPresencePurchase.type)
                .length > 0
            if (!exists) {
                this.currentLocalPresencePackages.push(localPresencePurchase)
            }

        })

        this.initialize()
    },

    methods: {
        initialize() {
            axios.get('/api/admin/addons/owned', {params: {company_id: this.company.id}}).then(({data}) => {
                this.currentLocalPresencePackages = data[ADDON_CATEGORY_LOCAL_PRESENCE]
            })
        },

        isInProgress(localPresencePackage) {
            return localPresencePackage.status === LP.LP_STATUS_DELETING
        },

        cancelLocalPresencePackage(localPresencePackage) {
            this.loading = true

            axios.delete(`/api/admin/company/${this.company.id}/local-presence-packages/${localPresencePackage.id}`)
                .then(() => {
                    let company = JSON.parse(JSON.stringify(this.company))
                    company.local_presence_packages = []

                    if (this.company.local_presence_packages) {
                        company.local_presence_packages = this.company.local_presence_packages.filter(localPresence => localPresence.type != localPresencePackage.type)
                    }

                    this.$emit('canceled', company)

                    this.$notify({
                        title: "Local Presence Cancellation",
                        message: 'Please wait. Canceling Local Presence will take a few minutes.',
                        type: "success",
                        showClose: true,
                    })

                    localPresencePackage.status = LP.LP_STATUS_DELETING
                    this.toggleVisibility()
                }).finally(() => {
                    this.loading = false
                })
        },

        getPackageName(localPresencePackage) {
            let name = this.localPresencesByType[localPresencePackage.type]?.name
            return name ?? '-'
        },

        getCountry(localPresencePackage) {
            let country = localPresencePackage.addon?.data?.country
            return country ?? '-'
        },

        getPrice(localPresencePackage) {
            let price = localPresencePackage.addon?.data?.price
            return price ?? '-'
        },

        toggleVisibility() {
            this.visible = !this.visible
        }
    },

    watch: {
        currentLocalPresencePackages(collection) {
            if (collection && collection.length == 0) {
                this.visible = false
            }
        }
    },

    computed: {
        shouldShowButton() {
            let shouldShow = false

            if (this.currentLocalPresencePackages) {
                shouldShow = this.currentLocalPresencePackages.length > 0
            }

            if (!shouldShow) {
                this.visible = false
            }

            return shouldShow
        }
    }
}
</script>
